import { Helmet } from "react-helmet";


export default function PageTitle({ title, iconURL = "" }) {
  return (
    <Helmet>
      <title>{title}</title>
      {
        iconURL !== "" &&
        <link rel="shortcut icon" href={iconURL} />
      }
    </Helmet>
  );
}